// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addnew_master_heading {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
  margin-top: 20px;
}
.newAddMasterForm_container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  padding: 20px;
  max-width: 1200px;
  margin: auto;
  background: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.newAddMasterForm_field {
  display: flex;
  flex-direction: column;
}

.newAddMasterForm_field label {
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 16px;
}

.newAddMasterForm_field input {
  padding: 10px 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 15px;
}

.newAddMasterForm_submit {
  margin-top: 20px;
  padding: 14px;
  background: linear-gradient(135deg, #6c63ff, #5a54d6);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.newAddMasterForm_submit:hover {
  background: linear-gradient(135deg, #5a54d6, #4c43b8);
}

/* ------------------------------
      Responsive Design
  ------------------------------ */

/* Tablet and above (min-width 768px) */
@media (min-width: 768px) {
  .newAddMasterForm_container {
    grid-template-columns: repeat(2, 1fr); /* 2 columns on tablets */
  }
}

/* Laptop and above (min-width 1024px) */
@media (min-width: 1024px) {
  .newAddMasterForm_container {
    grid-template-columns: repeat(3, 1fr); /* 3 columns on laptops/desktops */
  }
}

/* Very small mobile (max-width 480px) */
@media (max-width: 480px) {
  .newAddMasterForm_field label {
    font-size: 14px;
  }

  .newAddMasterForm_field input {
    font-size: 14px;
    padding: 8px 12px;
  }

  .newAddMasterForm_submit {
    font-size: 14px;
    padding: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Planning/newMasterAdd.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;kCAEkC;;AAElC,uCAAuC;AACvC;EACE;IACE,qCAAqC,EAAE,yBAAyB;EAClE;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,qCAAqC,EAAE,kCAAkC;EAC3E;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF","sourcesContent":[".addnew_master_heading {\n  font-size: 24px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 20px;\n  text-align: center;\n  margin-top: 20px;\n}\n.newAddMasterForm_container {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n  padding: 20px;\n  max-width: 1200px;\n  margin: auto;\n  background: #f9f9f9;\n  border-radius: 12px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.newAddMasterForm_field {\n  display: flex;\n  flex-direction: column;\n}\n\n.newAddMasterForm_field label {\n  font-weight: 600;\n  margin-bottom: 6px;\n  font-size: 16px;\n}\n\n.newAddMasterForm_field input {\n  padding: 10px 14px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 15px;\n}\n\n.newAddMasterForm_submit {\n  margin-top: 20px;\n  padding: 14px;\n  background: linear-gradient(135deg, #6c63ff, #5a54d6);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.newAddMasterForm_submit:hover {\n  background: linear-gradient(135deg, #5a54d6, #4c43b8);\n}\n\n/* ------------------------------\n      Responsive Design\n  ------------------------------ */\n\n/* Tablet and above (min-width 768px) */\n@media (min-width: 768px) {\n  .newAddMasterForm_container {\n    grid-template-columns: repeat(2, 1fr); /* 2 columns on tablets */\n  }\n}\n\n/* Laptop and above (min-width 1024px) */\n@media (min-width: 1024px) {\n  .newAddMasterForm_container {\n    grid-template-columns: repeat(3, 1fr); /* 3 columns on laptops/desktops */\n  }\n}\n\n/* Very small mobile (max-width 480px) */\n@media (max-width: 480px) {\n  .newAddMasterForm_field label {\n    font-size: 14px;\n  }\n\n  .newAddMasterForm_field input {\n    font-size: 14px;\n    padding: 8px 12px;\n  }\n\n  .newAddMasterForm_submit {\n    font-size: 14px;\n    padding: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
